import {memo} from 'react';

import styled from 'styled-components';

import {getLocalizationService} from '~/shared/services/localisationService';

const Button = styled.button`
  height: 32px;
  width: 88px;
  border: ${({theme}) => `1px solid ${theme.userReport.debitRequestsTable.buttonBorderColor}`};
  color: ${({theme}) => theme.userReport.debitRequestsTable.buttonColor};
  font-weight: bold;
  text-align: center;
`;

type CancelButtonProps = {
  onCancelClick: (arg: string | number) => void;
  transferData: Record<string, any>;
  mapDebitTransferStatus: {
    Validated: string;
    New: string;
  };
};

const CancelButton = ({onCancelClick, transferData, mapDebitTransferStatus}: CancelButtonProps) => {
  const {t} = getLocalizationService();
  const {debitTransferRequestStatus, transferId} = transferData;
  const showCancelButtonForStatuses = [mapDebitTransferStatus.Validated, mapDebitTransferStatus.New];

  if (!showCancelButtonForStatuses.includes(debitTransferRequestStatus)) {
    return null;
  }
  return <Button onClick={() => onCancelClick(transferId)}>{t('cancel')}</Button>;
};

export default memo(CancelButton);
